export default "__VITE_ASSET__DICziq7T__"